<template>
  <div class="propertysupervise">
    <div class="header">
      <div class="title">智能家居</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="position">
          <img :src="mobileResidentOffice3" alt="" />
        </div>
      </div>

      <div class="right">
        智能家电、智能门锁、智能照明等设备，一键轻松连接，体验不一样的社区智能化家居生活。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileResidentOffice3 from "../../../../assets/product/mobileResidentOffice3.png";

export default {
  setup() {
    return reactive({
      mobileResidentOffice3: mobileResidentOffice3,
    });
  },
};
</script>

<style scoped>
.propertysupervise {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .left .logo img {
  width: 332px;
}
.body .left .position img {
  width: 238px;
}
.body .left .position img:nth-of-type(1) {
  left: 100%;
}
.body .left .position img:nth-of-type(2) {
  left: 125%;
  bottom: 0;
}
.body .left .position img:nth-of-type(3) {
  left: 150%;
  bottom: 0;
}
.body .right {
  width: 92vw;
  margin: 22px auto 0;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
